import(/* webpackMode: "eager", webpackExports: ["Legal"] */ "/vercel/path0/src/components/Legal.tsx");
